import Header from './components/Header';
import Hero from './components/Hero';
import FaqSection from './components/sections/FaqSection';
import TopicsSection from './components/sections/TopicsSection';
import IndexSection from './components/sections/IndexSection';
import CardsSection from './components/sections/CardsSection';
import AboutSection from './components/sections/AboutSection';
import MediaSection from './components/sections/MediaSection';
import RankingSection from './components/sections/RankingSection';
import CarouselSection from './components/sections/CarouselSection';
import CommentsSection from './components/sections/CommentsSection';
import FeaturesSection from './components/sections/FeaturesSection';
import ContactSection from './components/sections/ContactSection';
import UpdatesSection from './components/sections/UpdatesSection';
import AppSection from './components/sections/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FaqSection />
        <TopicsSection />
        <IndexSection />
        <CardsSection />
        <AboutSection />
        <MediaSection />
        <RankingSection />
        <CarouselSection />
        <CommentsSection />
        <FeaturesSection />
        <ContactSection />
        <UpdatesSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}